<template>
  <div class="productPage">
    <!--图片-->
    <div class="imgBox">
      <div class="imageItem">
        <img :src="imgBoxUrl" class="el-image__inner">
      </div>
      <!--      <div class="imgText">
              <div>产品介绍</div>
              <div>YAG激光治疗仪YAG激光治疗仪YAG激光治疗仪YAG</div>
            </div>-->
    </div>
    <div class="contentBox" >
      <div class="cu_all">
      <div class="cu_head">
          <el-menu :default-active="numIndex" class="el-menu-demo cu_menu_l" mode="horizontal" @select="handleSelect">
            <el-menu-item  v-for="item in numList" :index="item.num" :indexPath = "item.path" class="cu_menu">{{item.tital}}</el-menu-item>
          </el-menu>
      </div>


      <div class="cu_body" v-show="showData.box1">
        <div class="cu_imge">
          <el-image
            style="width: 588px; height: 360px"
            :src="item1.imgUrl"
            :fit="contain"></el-image>
        </div>
        <div class="cu_d" >
          <div class="cu_dd">
            <div class="cu_d_1">
              <p class="cu_p_1">{{item1.text1}}</p>
              <p class="cu_p_2">{{item1.text2}}</p>
            </div>
            <div class="cu_d_1">
              <p class="cu_p_1">{{ item1.text3 }}</p>
              <p class="cu_p_2">{{item1.text4}}</p>
            </div>
            <div class="cu_d_1">
              <p class="cu_p_1">{{ item1.text5 }}</p>
              <p class="cu_p_2">{{ item1.text6 }}</p>
            </div>
          </div>
        </div>
      </div>

        <div class="cu_body" v-show="showData.box2">
          <div class="cu_imge">
            <el-image
              style="width: 588px; height: 360px"
              :src="item2.imgUrl"
              :fit="contain"></el-image>
          </div>
          <div class="cu_d">
            <div class="cu_dd">
              <div class="cu_d_1">
                <p class="cu_p_1">{{item2.text1}}</p>
                <p class="cu_p_2">{{item2.text2}}</p>
              </div>
              <div class="cu_d_1">
                <p class="cu_p_1">{{item2.text3}}</p>
                <p class="cu_p_2">{{item2.text4}}</p>
              </div>
              <div class="cu_d_1">
                <p class="cu_p_1">{{item2.text5}}</p>
                <p class="cu_p_2">{{ item2.text6 }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "contactUs",
  data() {
    return {
      imgBoxUrl:"http://116.62.38.250//image//nr/tp/lxwm.jpg",
      urlData:"",
      showData:{
        box1: false,
        box2: false
      },
      numIndex: "1",
      numList : [
        {
          num : "1",
          tital : "Beijing, China",
          path:"zgbj"
        },
        {
          num : "2",
          tital : "Suzhou, China",
          path:"zgsz"
        }
      ],
      item1:{
        imgUrl:"http://116.62.38.250//image/nr/lxwm/bj.png",
        text1:"Address",
        text2:"Building 11, Units 201 & 202, No. 12 Courtyard, Juyuan Middle Road, Mapo Town, Shunyi District, Beijing, China",
        text3:"Phone",
        text4:"+86 010-56467587",
        text5:"Email",
        text6:"victrum0430@gmail.com"
      },
      item2:{
        imgUrl:"http://116.62.38.250//image/nr/lxwm/sz.png",
        text1:"Address",
        text2:"1st Floor, Building A, Phase 1, Wuzhong Biopharmaceutical Industrial Park, No. 999 Yinshanhu Road, Guoxiang, Wuzhong District, Suzhou, Jiangsu, China",
        text3:"Phone",
        text4:"400-178-1617",
        text5:"Email",
        text6:"victrum0430@gmail.com"
      }
    }
  },
  mounted() {
    let that = this;
    console.log("init");
    that.init();
  },
  created() {
    let that = this;
    that.urlData = that.$route.query.path;
    console.log(that.urlData);

  },
  methods: {
    init(){
      let that = this;
      console.log(that.urlData);
      console.log(that.urlData == undefined);
      if(that.urlData == "" || that.urlData == undefined){
        that.handleSelect("1",'zgbj')
      } else {
        let index = "1";
        if(that.urlData == 'zgbj'){
          index = "1";
        } else if (that.urlData == 'zgsj'){
          index = "2";
        }

        that.handleSelect(index,that.urlData)
      }

    },

    handleSelect(index, path) {
      let that = this;
      that.numIndex = index;
      console.log(index+path)  //获取tab标签的选中值
      console.log(index, path);
      //初始化
      that.showData.box1 = false;
      that.showData.box2= false;

      if(index == '1'){
        that.showData.box1 = true;
      } else if (index == '2'){
        that.showData.box2 = true;
      }
    }
  }
}
</script>

<style scoped>
.cu_d_1{
  margin-bottom: 20px;
}
.cu_d{
  display: flex;
  align-items: center;
  margin-left: 50px;
  margin-top: 50px;

}
.cu_imge{
  margin-top: 50px;
}
.cu_dd{
  margin: 30px auto;

}
.cu_body{
  display: flex;
  margin-bottom: 30px;
}
.cu_all{
  width: 1176px;
}
.cu_p_1{
  font-family: SourceHanSansCN;
  font-size: 16px;
  text-align: justify;
}
.cu_p_2{
  font-family: SourceHanSansCN;
  font-size: 18px;
  text-align: justify;
}
.cu_menu_l{
  width: 100%;
  border: none;
}
.cu_head{
  width: 100%;
  display: flex;
}
.cu_menu{
  display: flex;
  justify-content: center;
  width: 50%;
}
.contentBox {
  width: 1176px;
  margin: 50px auto;
  display: flex;
  justify-content: center;
}
.productPage {
  display: block;
  width: 1920px;
  background-color: #FFFFFF;
}
.imgBox {
  width: 100%;
  height: 600px;
}

.imageItem {
  height: 100%;
}

</style>



// WEBPACK FOOTER //
// src/components/en/contactUs.vue